






























import { Component, Vue } from 'vue-property-decorator';
import { hideOverlay } from '@/util/common/overlay';

/**
 * 未検出エラー画面.
 */
@Component({
  name: 'NotFound'
})
export default class NotFound extends Vue {
  // リダイレクトフラグ
  // NOTE：TRUE = 画面描写しない / FALSE = 画面描写される
  private isRedirect: boolean = false;
  // 初期化処理
  public async mounted(): Promise<void> {
    hideOverlay();
  }
  private created() {
    const redirected = this.$route.query.redirected;
    if (!redirected) {
      // リダイレクト後は、クエリパラメータ（rediredted）が設定されてるため、trueにならない
      this.isRedirect = true;
      window.location.href = `${process.env.VUE_APP_HOST_URL}redirect/not/found`;
    }
  }
}
